export default "__VITE_ASSET__EdhkOlC2__"